module.exports = __webpack_public_path__ + "ico-web-right.564ffd9fec93fefe46cd.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@c4/assets/src/assets/images/icons/ico-web-right.svg
// module id = 360
// module chunks = 2